import React, { useEffect, useState } from "react";
import AlumnoLayout from "@/components/AlumnoLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Calendar, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function Sesiones() {
  const { user } = useAuth();
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    api.get("/alumno/live-sessions/upcoming").then((r) => setSessions(r.data));
  }, []);

  const downloadIcs = async (id) => {
    try {
      const res = await api.get(`/alumno/live-sessions/${id}/ics`, { responseType: "blob" });
      const blob = new Blob([res.data], { type: "text/calendar" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = `dcc-${id}.ics`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
      toast.success("Calendario descargado");
    } catch { toast.error("No se pudo descargar"); }
  };

  const future = sessions.filter((s) => s.is_future);
  const past = sessions.filter((s) => !s.is_future);

  return (
    <AlumnoLayout user={user}>
      <div>
        <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">Sesiones en vivo</p>
        <h1 className="mt-2 text-3xl font-bold text-white font-display">Sesiones sincrónicas</h1>

        <section className="mt-8">
          <h2 className="text-sm uppercase tracking-widest text-gray-400 mb-3">Próximas ({future.length})</h2>
          {future.length === 0 ? (
            <div className="p-6 border border-dashed border-gray-800 rounded-xl text-gray-400 text-sm">No hay sesiones próximas.</div>
          ) : (
            <div className="grid md:grid-cols-2 gap-3" data-testid="live-upcoming">
              {future.map((s) => <SessionCard key={s.lesson_id} s={s} onIcs={() => downloadIcs(s.lesson_id)} />)}
            </div>
          )}
        </section>

        {past.length > 0 && (
          <section className="mt-10">
            <h2 className="text-sm uppercase tracking-widest text-gray-400 mb-3">Pasadas</h2>
            <div className="grid md:grid-cols-2 gap-3">
              {past.map((s) => <SessionCard key={s.lesson_id} s={s} onIcs={() => downloadIcs(s.lesson_id)} past />)}
            </div>
          </section>
        )}
      </div>
    </AlumnoLayout>
  );
}

function SessionCard({ s, onIcs, past }) {
  return (
    <div className={`p-5 rounded-xl border ${past ? "border-gray-800 bg-[#0F172A] opacity-70" : "border-gray-800 bg-[#111827]"}`}>
      <p className="text-[10px] uppercase tracking-widest text-[#93C5FD]">{s.program_title}</p>
      <p className="mt-1 font-semibold text-white">{s.title}</p>
      <p className="mt-1 text-sm text-gray-300 font-mono">{new Date(s.starts_at).toLocaleString("es-MX")}</p>
      <div className="mt-3 flex gap-2">
        {!past && (
          <>
            <a href={s.zoom_url || "#"} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded bg-[#B84A0C] text-white hover:bg-primary">
              <ExternalLink className="w-3 h-3" /> Zoom
            </a>
            <button onClick={onIcs}
              className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded border border-gray-700 text-gray-200 hover:bg-white/5">
              <Calendar className="w-3 h-3" /> .ics
            </button>
          </>
        )}
      </div>
    </div>
  );
}
